import { useTheme } from '@mui/material';
import type { ComponentPropsWithoutRef, CSSProperties } from 'react';

interface ThemeAwareLogoProps extends ComponentPropsWithoutRef<'img'> {
    tintInDarkMode?: boolean;
}

export const ThemeAwareLogo = ({
    alt,
    className,
    src,
    style,
    tintInDarkMode = false,
    title,
    ...imageProps
}: ThemeAwareLogoProps) => {
    const theme = useTheme();

    if (!src || !tintInDarkMode || theme.palette.mode !== 'dark') {
        return (
            <img
                {...imageProps}
                src={src}
                alt={alt}
                className={className}
                style={style}
                title={title}
            />
        );
    }

    const maskStyle: CSSProperties = {
        gridArea: '1 / 1',
        width: '100%',
        height: '100%',
        backgroundColor: theme.resqPalette.brand.orange,
        maskImage: `url("${src}")`,
        maskPosition: 'center',
        maskRepeat: 'no-repeat',
        maskSize: 'contain',
        WebkitMaskImage: `url("${src}")`,
        WebkitMaskPosition: 'center',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
    };

    return (
        <span
            aria-hidden={alt ? undefined : true}
            aria-label={alt || undefined}
            className={className}
            role={alt ? 'img' : undefined}
            style={{ ...style, display: 'inline-grid', lineHeight: 0 }}
            title={title}
        >
            <img
                {...imageProps}
                src={src}
                alt=""
                aria-hidden
                style={{
                    ...style,
                    display: 'block',
                    gridArea: '1 / 1',
                    visibility: 'hidden',
                }}
            />
            <span aria-hidden style={maskStyle} />
        </span>
    );
};
